module.exports = __webpack_public_path__ + "img/news_home_2.1c5b2b72.jpg";